export const SELLER_FEATURE_NAME = 'seller';
